<template>
  <div class="mt-3">
    <UsageFilesTable />
  </div>
</template>

<script>
import UsageFilesTable from "../../Modules/UsageFilesTable"
import { mapActions } from "vuex"

export default {
  name: "UsageFilesPage",
  components: {
    UsageFilesTable
  },
  beforeRouteLeave (to, from, next) {
    this.clearFilters()
    next()
  },
  data () {
    return {}
  },
  methods: {
    ...mapActions("ui", ["clearFilters"])
  },
}
</script>
